"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WinstonConsumer = exports.WinstonProvider = void 0;
var WinstonProvider_1 = require("./WinstonProvider");
Object.defineProperty(exports, "WinstonProvider", { enumerable: true, get: function () { return __importDefault(WinstonProvider_1).default; } });
var WinstonConsumer_1 = require("./WinstonConsumer");
Object.defineProperty(exports, "WinstonConsumer", { enumerable: true, get: function () { return __importDefault(WinstonConsumer_1).default; } });
__exportStar(require("./WinstonConsumer"), exports);
__exportStar(require("./WinstonContext"), exports);
__exportStar(require("./WinstonProvider"), exports);
//# sourceMappingURL=index.js.map